import { PiBatteryHighBold } from 'react-icons/pi'
import '../../../../App.css'

const Videos = () => {
    return (
        <fieldset className="max-w-screen-xs md:max-w-screen-lg text-center my-10 mx-auto p-5 md:p-10 border-slate-800 dark:border-white border-4 dark:text-white">
            <legend className="font-[blanka] text-3xl">Videos</legend>
            <div className="flex justify-between items-center mb-5">
                <span>
                    <PiBatteryHighBold className="battery text-3xl" />
                </span>
                <div className="flex items-center gap-4">
                    <span className="text-2xl font-bold">Rec</span>
                    <span className="red-dot"></span>
                </div>
            </div>
            <div>
                {/* First Row */}
                <div className="block md:flex gap-5 mb-5">
                    <iframe
                        src="https://www.youtube.com/embed/SU0seOgDBuk?si=iO1m26OfTiEWuXCZ"
                        title="Heart Strings 2 [Full Beattape]"
                        className="w-full md:w-1/2 h-64 md:h-72"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen
                    ></iframe>
                    <iframe
                        src="https://www.youtube.com/embed/osnoyWoZm1A?si=SSLKdzS0kC7rxiQR"
                        title="&quot;BAD LUCK&quot; [Full Album] Music Video"
                        className="w-full md:w-1/2 h-64 md:h-72"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen
                    ></iframe>
                </div>
                {/* Second Row */}
                <div className="block md:flex gap-5">
                    <iframe
                        src="https://www.youtube.com/embed/CcArqASqlS8?si=KnTzNMpzjbcEirfx"
                        title="Studio Mercy Deadbeat [Full Album]"
                        className="w-full md:w-1/2 h-64 md:h-72"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen
                    ></iframe>
                    <iframe
                        src="https://www.youtube.com/embed/-Q9HgSQdUiI?si=d5nUPKHVjKCe3yhh"
                        title="AMPED UP [ NYAN0BYTE's Stream Commission]"
                        className="w-full md:w-1/2 h-64 md:h-72"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen
                    ></iframe>
                </div>
            </div>
        </fieldset>

    )
}

export default Videos